import { TranslationKey } from './../../../../../types/translation/TranslationKey';

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 } from 'uuid';
import { ProductMasterData } from '../../../../../types/product_master_data/productMasterData';
import { t } from '../../../../../types/translation/Translator';
import { Button } from '../../../../components/Button';
import { ButtonVariant } from '../../../../components/Button/Button';
import { OnboardingStep, OnboardingSubtitle, OnboardingTitle } from '../../components';
import OnboardingPaneHeader from '../../components/OnboardingPaneHeader';
import { OnboardingData, OnboardingRoutes } from '../..';
import OnboardingReferenceDataForm from './components/OnboardingReferenceDataForm';
import { ProductMasterDataInput } from '../../../../../types/product_master_data';

interface OnboardingReferenceDataAddPaneProps {
  data: OnboardingData;
  setData: (data: OnboardingData) => void;
}

export default function OnboardingReferenceDataAddPane({ data, setData }: OnboardingReferenceDataAddPaneProps) {
  const navigate = useNavigate();

  const [productMasterData, setProductMasterData] = useState(
    new ProductMasterData({ companyId: data.company.id, id: v4() }),
  );

  return (
    <div className='grid gap-4'>
      <OnboardingPaneHeader back={() => navigate(-1)} />

      <div className='grid gap-1'>
        <OnboardingStep />
        <OnboardingTitle text={'Add product reference data manually'} />
        <OnboardingSubtitle
          text={
            'Define your product reference data to standardize product information across your inventory. This helps ensure consistent tracking and identification of your products.'
          }
        />
      </div>
      <OnboardingReferenceDataForm
        existing={data.summary.productMasterData}
        productMasterData={productMasterData}
        setProductMasterData={setProductMasterData}
      />
      <div className='flex gap-2'>
        <Button
          text={t(TranslationKey.add).singular.label}
          onClick={() => {
            data.manual.productMasterData.set(productMasterData.id, new ProductMasterDataInput(productMasterData));
            setData(data);
            navigate(OnboardingRoutes.referenceDataOverview);
          }}
        />
        <Button
          text={t(TranslationKey.cancel).singular.label}
          onClick={() => navigate(-1)}
          variant={ButtonVariant.linkPrimary}
        />
      </div>
    </div>
  );
}
